import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {
  APP_INITIALIZER,
  ModuleWithProviders,
  NgModule,
  Optional,
  SkipSelf,
} from '@angular/core';
import { StorageService } from '@app/services/cookie-storage.service';
import {
  OAuthModule,
  OAuthModuleConfig,
  OAuthStorage,
} from 'angular-oauth2-oidc';
import { AuthentificationModuleConfig } from './authentification.config';
import { configurationInitializerFactory } from './configuration.initializer';
import { ConfigurationService } from './configuration.service';
import { OAuthInterceptor } from './oauth.interceptor';

@NgModule({ imports: [OAuthModule.forRoot()], providers: [ConfigurationService, provideHttpClient(withInterceptorsFromDi())] })
export class ConfigurationModule {
  static forRoot(): ModuleWithProviders<ConfigurationModule> {
    return {
      ngModule: ConfigurationModule,
      providers: [
        {
          provide: APP_INITIALIZER,
          useFactory: configurationInitializerFactory,
          deps: [ConfigurationService],
          multi: true,
        },
        { provide: OAuthModuleConfig, useValue: AuthentificationModuleConfig },
        { provide: OAuthStorage, useClass: StorageService },
        { provide: HTTP_INTERCEPTORS, useClass: OAuthInterceptor, multi: true },
        StorageService,
      ],
    };
  }

  constructor(@Optional() @SkipSelf() parentModule: ConfigurationModule) {
    if (parentModule) {
      throw new Error(
        'ConfigurationModule is already loaded. Import it in the AppModule only',
      );
    }
  }
}
